import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

interface RichTextDisplayProps {
  content: string | null | undefined;
  className?: string;
}

const RichTextDisplay = ({ content, className }: RichTextDisplayProps) => {
  if (!content) return null;

  // Check if content is HTML or plain text
  const isHtml = /<[a-z][\s\S]*>/i.test(content);
  
  if (isHtml) {
    const sanitizedHtml = DOMPurify.sanitize(content, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'a', 'span'],
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
    });

    return (
      <div 
        className={cn("rich-text-content prose prose-sm max-w-none text-muted-foreground", className)}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  }

  // For plain text, convert line breaks and bullet points
  const formattedText = content
    .split('\n')
    .map((line, index) => {
      // Convert * at start of line to bullet point
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith('*') || trimmedLine.startsWith('-')) {
        return (
          <li key={index} className="ml-4">
            {trimmedLine.substring(1).trim()}
          </li>
        );
      }
      return line ? <p key={index}>{line}</p> : <br key={index} />;
    });

  return (
    <div className={cn("text-sm text-muted-foreground", className)}>
      {formattedText}
    </div>
  );
};

export default RichTextDisplay;
